/* eslint-disable no-console */
/* eslint-disable no-shadow */
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
import { useNavigate, useParams } from "react-router-dom";
import { Image } from "react-bootstrap";
import Loader from "../global/Loader";
import authservice from "../services/auth.services";
import { getRazorpayCredentials } from "./GetRazorpayCredentials";
import { loadRazorpayScript } from "./LoadRazorpayScript";
import { verifyRazorPay } from "./VerifyRazorPay";
import { initiatePayment } from "./InitiateUrlRazorpayPayment";

const UrlPayment = () => {
  const { transactionNo } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [transactionInfo, setTransactionInfo] = useState(null);
  const [paymentInitiated, setPaymentInitiated] = useState(false);

  const { keyId } = getRazorpayCredentials();
  const secretKey = process.env.REACT_APP_CRYPTJS_SECRET_KEY;

  const validateTransaction = async () => {
    try {
      const response = await authservice.postJsonData(
        "validateStoreWalletTransaction",
        { transactionNo },
      );
      return response;
    } catch (err) {
      console.error(
        `Error validating transaction number ${transactionNo}:`,
        err,
      );
      throw err;
    }
  };

  const updateTransactionStatus = async (
    currentStatus,
    transactionNo,
    orderId,
    responseData,
  ) => {
    try {
      return await authservice.postJsonData("updateWalletTransactionStatus", {
        currentStatus,
        transactionNo,
        orderId,
        responseData,
      });
    } catch (err) {
      console.error(`Status update failed (${transactionNo})`, err);
      throw err;
    }
  };

  const ValidateTrnx = async (transactionNum) => {
    try {
      const response = await validateTransaction(transactionNum);

      if (response?.apiResponseCode === "1001" && response?.data?.length > 0) {
        setTransactionDetails(response.data[0]);
        return true;
      }

      // Swal.fire({
      //   icon: "error",
      //   html: response?.apiResponseMsg || "Invalid transaction",
      //   confirmButtonText: "OK",
      //   customClass: { confirmButton: "custom-confirm-button" },
      //   allowOutsideClick: false,
      // });

      return false;
    } catch (error) {
      Swal.fire({
        icon: "error",
        html: "Transaction validation failed. Please try again.",
        confirmButtonText: "OK",
        customClass: { confirmButton: "custom-confirm-button" },
        allowOutsideClick: false,
      });
      return false;
    }
  };

  const openRazorpay = async (transactionNum) => {
    if (!transactionNum || !transactionDetails) {
      Swal.fire({
        title: "Oops...",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "custom-confirm-button",
        },
        icon: "error",
        html: "Transaction Details Not Available",
      });
      return;
    }
    const scriptLoaded = await loadRazorpayScript();
    if (!scriptLoaded) {
      Swal.fire({
        title: "Oops...",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "custom-confirm-button",
        },
        icon: "error",
        html: "Razorpay Sdk Failed To Load",
      });
      return;
    }

    setLoading(true);
    const paymentOptions = {
      key: keyId,
      name: "Conjoinix Total Solution Pvt Ltd",
      description: "Test Transaction",
      image: "https://example.com/logo.png",
      method: {
        upi: true,
      },
      prefill: {
        email: "conjoinix2023@gmail.com",
        contact: "8966857291",
      },
      handler: async (response) => {
        setLoading(false);
        if (response.razorpay_payment_id) {
          const verificationResult = await verifyRazorPay(response);
          if (verificationResult.success) {
            const transactionResult = await updateTransactionStatus(
              "SUCCESS",
              transactionNum,
              response.razorpay_order_id,
              JSON.stringify(response),
            );
            if (transactionResult.apiResponseCode == 1001) {
              const encrypt = (value) => {
                return CryptoJS.AES.encrypt(
                  value?.toString(),
                  secretKey,
                )?.toString();
              };

              const encryptedTrnxNo = encrypt(transactionDetails.transactionNo);
              const encryptedAmount = encrypt(transactionDetails.amount);
              navigate(
                `/payment-success?transactionId=${encodeURIComponent(encryptedTrnxNo)}&amount=${encodeURIComponent(encryptedAmount)}`,
              );
            } else {
              setLoading(false);
              Swal.fire({
                title: "Error",
                confirmButtonText: "OK",
                customClass: {
                  confirmButton: "custom-confirm-button",
                },
                icon: "error",
                html: transactionResult.apiResponseMsg,
              });
            }
          } else {
            await updateTransactionStatus(
              "FAILED",
              transactionNum,
              response.razorpay_order_id,
              JSON.stringify(response),
            );
            navigate("/payment-failed");
          }
        } else {
          await updateTransactionStatus(
            "FAILED",
            transactionNum,
            response.razorpay_order_id,
            JSON.stringify(response),
          );
          navigate("/payment-failed");
        }
      },
      modal: {
        // confirm_close: false,
        escape: false,
        backdropclose: false,
        ondismiss: () => {
          navigate("/payment-cancel");
          setLoading(false);
        },
        closebyclickingoutside: false,
      },
    };
    initiatePayment(paymentOptions, transactionDetails?.orderID, setLoading);
  };

  useEffect(() => {
    const initializePayment = async () => {
      if (!transactionNo) {
        Swal.fire({
          title: "Error",
          icon: "error",
          confirmButtonText: "OK",
          customClass: { confirmButton: "custom-confirm-button" },
          html: "Missing or invalid transaction number in URL.",
          allowOutsideClick: false,
        });
        navigate("/payment-cancel");
        return;
      }

      try {
        const isValid = await ValidateTrnx(transactionNo);
        if (isValid) {
          setTransactionInfo({ transactionNo });
        } else {
          navigate("/payment-paid");
        }
      } catch (error) {
        console.error("Error in payment initialization:", error);
        navigate("/payment-paid");
      }
    };

    initializePayment();
  }, []);

  useEffect(() => {
    if (transactionDetails && transactionInfo && !paymentInitiated) {
      setPaymentInitiated(true);
      openRazorpay(transactionInfo.transactionNo);
    }
  }, [transactionDetails, transactionInfo, paymentInitiated]);

  return (
    <div className="payment-process">
      <h4>Please Wait — Payment is Being Processed</h4>

      <div
        className="spinner-border text-success"
        style={{ width: "4em", height: "4em" }}
        role="status"
      />

      {loading && <Loader />}
      <Image src="/images/payment-processing.svg" alt="processing" />
    </div>
  );
};

export default UrlPayment;
